<div fxLayout="column">
  <div fxLayout="row" fxLayoutGap="10px" fxLayout.xs="column" fxLayoutGap.xs="0">
    <div fxFlex>
      <mat-form-field class="full-width">
        <mat-label>{{ 'crm.task.subject'|translate }}</mat-label>
        <input matInput [placeholder]="'crm.task.subject'|translate" [(ngModel)]="task.subject">
      </mat-form-field>
    </div>
    <div fxFlex>
      <mat-form-field class="full-width">
        <mat-label>{{ 'crm.task.body'|translate }}</mat-label>
        <input matInput [placeholder]="'crm.task.body'|translate" [(ngModel)]="task.body">
      </mat-form-field>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="10px" fxLayout.xs="column" fxLayoutGap.xs="0">
    <div fxFlex>
      <mat-form-field class="full-width">
        <mat-label>{{ 'crm.task.due_date' | translate }}</mat-label>
        <input matInput [matDatepicker]="dueDate" [(ngModel)]="task.dueDate"
          placeholder="{{ 'crm.task.due_date' | translate }}">
        <mat-datepicker-toggle matSuffix [for]="dueDate"></mat-datepicker-toggle>
        <mat-datepicker #dueDate></mat-datepicker>
      </mat-form-field>
    </div>
    <div fxFlex>
      <flex-time-picker [(ngModel)]="task.atDt" placeholder="{{ 'crm.task.at_dt' | translate }}">
      </flex-time-picker>
    </div>
  </div>
</div>
